import {defineMessages} from 'react-intl';

const messages = defineMessages({
  campaign_stars: {
    id: 'campaign_stars',
    defaultMessage: '{numberOfStars, number} {numberOfStars, plural, one {star} other {stars}}'
  }
});

export default messages;
